<template>
  <div class="badge-icon-container">
    <img class='badge-icon' :src="achievementImageSrc" :alt="badgeName || 'Achievement badge'"/>
    <button type="button" v-if="removable" class="remove-badge" aria-label="Remove badge" @click="$emit('remove')">
      <i class="fas fa-times-circle" aria-hidden="true"></i>
    </button>
    <div class="threshold-score">{{ thresholdScore }}%</div>
  </div>
</template>

<style scoped>
.badge-icon-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.badge-icon-container img {
  height: 50px;
  width: auto;
}

.remove-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  cursor: pointer;
  height: 20px;
  width: 20px;
  text-align: center;
  border-radius: 50%;
  padding: 0;
  border: none;
  background: transparent;
}

.remove-badge i {
  color: var(--kate-danger);
}

.threshold-score {
  margin: auto;
  text-align: center;
}
</style>

<script>
import { GOOGLE_CLOUD_STORAGE } from '../../constants';

export default {
  props: {
    removable: {
      type: Boolean,
      default: false,
    },
    iconImage: {
      type: String,
      default: '',
    },
    badgeName: {
      type: String,
      default: '',
    },
    thresholdScore: {
      type: Number,
      default: null,
    },
  },

  computed: {
    achievementImageSrc() {
      return `${GOOGLE_CLOUD_STORAGE}${this.iconImage}`;
    },
  },
};
</script>
